/**
 * Module dependencies.
 */

import {
  CrudAddType,
  CrudEditType,
  CrudListType,
  CrudTemplate,
  FormList
} from 'app/components/organisms/crud/form-types';
import { normalizeTemplate } from 'app/components/organisms/crud/utils';
import { apiEndpoints } from 'app/core/config/api-endpoints';
import { requiredRule } from 'app/core/utils/field-rules';
import { appRoutes } from 'app/routes';
import { TFunction } from 'i18next';

/**
 * Form list.
 */

const formFields = (translate: TFunction): FormList => [
  {
    type: 'inputField',
    name: 'name',
    label: translate('common.labels.name'),
    rules: requiredRule(translate)
  },
  {
    type: 'sliderField',
    name: 'defaultIVA',
    label: translate('common.labels.defaultIVA'),
    rules: requiredRule(translate)
  },
  {
    type: 'inputField',
    name: 'areaM2',
    label: translate('common.labels.areaM2'),
    rules: undefined
  }
];

/**
 * Coerce the optional area field to a number (or null) for the API.
 */

const normalizePayload = (data: any) => ({
  ...data,
  areaM2: data.areaM2 === '' || data.areaM2 == null ? null : Number(data.areaM2)
});

/**
 * Add.
 */

const add = (translate: TFunction): CrudAddType => ({
  formFields: formFields(translate),
  endpoint: apiEndpoints.projectsAdd,
  normalizePayload
});

/**
 * Edit.
 */

const edit = (translate: TFunction): CrudEditType => ({
  formFields: formFields(translate),
  normalizePayload
});

/**
 * List.
 */

const list = (): CrudListType => ({
  columns: [],
  route: appRoutes.dashboard.projects.base,
  key: ['projects'],
  endpoint: apiEndpoints.projects
});

/**
 * Config.
 */

export function createProjectsTemplate(translate: TFunction): CrudTemplate {
  return normalizeTemplate(translate, {
    add: add(translate),
    edit: edit(translate),
    list: list()
  });
}
